import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const HectoResult = () => {
  return <CommonResult />;
};

export default HectoResult;
